import { Pagination } from "@infinitaslearning/pixel-design-system";
import { observer } from "mobx-react";
import type React from "react";
import { useEffect, useState } from "react";

import { Player } from "components/Player/Player";

import { CssFlex } from "styles/helpers/layout";
import { StyledPlayerContainer } from "../../EdifyTopicDetailsPage.styled";

import type { FlashcardRendererProps } from "./FlashcardRenderer.types";

/**
 *  This component allows user to see the list of flashcards one by one,
 * in the same order they're defined in the content. It'd be also possible
 * to navigate through the different items using the paginator.
 */
export const FlashcardCarouselRenderer: React.FC<FlashcardRendererProps> = observer(
  ({ contentSets = [] }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [showFlashcard, setShowFlashcard] = useState(false);

    // Set show flashcard to true every time selected page changes
    useEffect(() => {
      setShowFlashcard(true);
    }, [currentPage]);

    // Temporarily hide flashcard to force Player to re-render on page change
    const onPageChange = (_event: React.ChangeEvent<unknown>, page: number) => {
      setShowFlashcard(false);
      setCurrentPage(page);
    };

    const currentFlashCard = contentSets[currentPage - 1];

    return (
      <CssFlex flexDirection="column" rowGap={2}>
        {showFlashcard && (
          <StyledPlayerContainer data-cy="edify-flashcard-content">
            <Player
              id={`player-${currentFlashCard.id}`}
              data={{ topics: [currentFlashCard.content] }}
              config={{ superSubmitButton: null }}
            />
          </StyledPlayerContainer>
        )}
        <Pagination
          data-cy="flashcard-pagination"
          page={currentPage}
          count={contentSets.length}
          onChange={onPageChange}
        />
      </CssFlex>
    );
  },
);
